import * as Sentry from '@sentry/react';
import { confirmAlert } from 'react-confirm-alert';
import _ from 'underscore';

import imgEAU from '@img/campusLogos/UWEauClaire.png';
import imgEAU_BRN from '@img/campusLogos/EAU_BRN.png';
import imgGBY from '@img/campusLogos/UWGreenBay.png';
import imgMAN from '@img/campusLogos/MAN.png';
import imgMNT from '@img/campusLogos/MNT.png';
import imgSHB from '@img/campusLogos/SHB.png';
import imgLAC from '@img/campusLogos/UWLacrosse.png';
import imgMSN from '@img/campusLogos/UWMadison.png';
import imgMIL from '@img/campusLogos/UWMilwaukee.png';
import imgWAK from '@img/campusLogos/WAK.png';
import imgWSH from '@img/campusLogos/WSH.png';
import imgOSH from '@img/campusLogos/UWOshkosh.png';
import imgFDL from '@img/campusLogos/FDL.png';
import imgFOX from '@img/campusLogos/FOX.png';
import imgPKS from '@img/campusLogos/UWParkside.png';
import imgPLT from '@img/campusLogos/UWPlatteville.png';
import imgBRB from '@img/campusLogos/BRB.png';
import imgRLN from '@img/campusLogos/RLN.png';
import imgRVF from '@img/campusLogos/UWRiverfalls.png';
import imgSTP from '@img/campusLogos/UWStevensPoint.png';
import imgMSF from '@img/campusLogos/MSF.png';
import imgMTH from '@img/campusLogos/MTH.png';
import imgSTO from '@img/campusLogos/UWStout.png';
import imgSUP from '@img/campusLogos/UWSuperior.png';
import imgWTW from '@img/campusLogos/UWWhitewater.png';
import imgRCK from '@img/campusLogos/RCK.png';
import imgXMI from '@img/campusLogos/UWMilwaukee.png';
import imgXPK from '@img/campusLogos/UWParkside.png';

const { VITE_ENV } = import.meta.env,
	not_local = ['staging', 'practice', 'production'].includes(VITE_ENV);

export const FILE_UPLOAD = {
		min_file_size: 1000,
		err_msg: {
			title: 'Error Uploading File',
			message:
				"The file you've uploaded does not meet our minimum file size.  Please check that the file has been properly saved and try again.",
			buttons: [{ label: 'OK' }]
		}
	},
	SENTRY = {
		use: not_local,
		set_tag: (prop, val) => {
			if (!val) val = '';

			if (not_local) Sentry.setTag(prop, val.substr(0, 200));
		},
		log: ex => {
			if (!ex) ex = '';

			if (not_local) Sentry.captureException(ex);
		}
	},
	formatMonth = str => {
		const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
			strMonth = str.split('/')[0],
			strYear = str.split('/')[1],
			month = months[Number(strMonth) - 1];

		return `${month} ${strYear}`;
	},
	cloneDeep = (_val = {}, _valDefault = {}) => {
		let val = JSON.parse(JSON.stringify(_val)),
			valDefault = JSON.parse(JSON.stringify(_valDefault)),
			obj = {};

		if (!Object.keys(valDefault).length) return val;

		Object.keys(valDefault).forEach(key => {
			obj[key] = typeof val[key] === 'undefined' ? valDefault[key] : val[key];
		});

		return obj;
	},
	isJsonString = str => {
		try {
			JSON.parse(str);
		} catch (e) {
			return false;
		}

		return true;
	},
	onlyUnique = (value, index, self) => {
		return self.indexOf(value) === index;
	},
	cleanString = str => {
		str = (str || '')
			.replace(/[\u2018\u2019\u2032\u2035]/g, "'") // directional single quotes (or similar)
			.replace(/[\u201C\u201D\u2033\u2036]/g, '"') // directional double quotes (or similar)
			.replace(/[\u2013\u2014\u2015]/g, '-') // special dashes
			.replace(/[\u2026]/g, '...'); // ellipsis

		const dirty_str = `${str}`;

		str = str
			.replace(/[^\x00-\x7F]/g, '') // any remaining chars with ASCII code greater than 127
			.replace(/&([^\s]*);/g, '') // html-escaped characters
			.replace(/&#([^\s]*)/g, '') // more html-escaped characters
			.replace(/<|>/g, ''); // < or >

		return {
			clean: str,
			dirty: str === dirty_str ? '' : dirty_str
		};
	},
	adminUrl = use_cdn => {
		const urls = {
			local: 'https://admin.devapp.wisconsin.edu/api/',
			staging: 'https://admin.devapp.wisconsin.edu/api/',
			practice: 'https://admin.practiceapp.wisconsin.edu/api/',
			production: use_cdn
				? 'https://d2dbtqz9gq3ks4.cloudfront.net/api/'
				: 'https://admin.apply.wisconsin.edu/api/'
		};

		return urls[VITE_ENV];
	},
	scrollTo = (y = 0, x = 0) => {
		try {
			window.scrollTo({ top: y, left: x, behavior: 'smooth' });
		} catch (ex) {
			window.scrollTo(x, y);
		}
	},
	toggleArray = (arr, val) => {
		arr = [...arr];

		let i = arr.indexOf(val);

		if (i > -1) {
			arr.splice(i, 1);
		} else {
			arr.push(val);
		}

		return arr;
	},
	addrIsPOBox = addr => {
		// checks whether or not the input begins with some variation of "P.O. Box"

		if ((addr.country || 'USA') === 'USA') {
			if (
				!(addr.address_1 || '')
					.replace(/[^a-zA-Z\d]+/g, '')
					.toLowerCase()
					.indexOf('pobox')
			) {
				return 'address_1';
			}

			if (
				!(addr.address_2 || '')
					.replace(/[^a-zA-Z\d]+/g, '')
					.toLowerCase()
					.indexOf('pobox')
			) {
				return 'address_2';
			}
		}

		return '';
	},
	findReferrer = (rec, referrer_to_find) => {
		let _rec = cloneDeep(rec);
		delete _rec._created;
		delete _rec._submitted;

		return _.isEqual(_rec, referrer_to_find);
	},
	equalExcept = (_a, _b, _arrFields, ignoreSort = true) => {
		let a = cloneDeep(_a || {}),
			b = cloneDeep(_b || {}),
			arrFields = _arrFields || [];

		Object.keys(a).forEach(key => {
			if (arrFields.includes(key)) {
				delete a[key];
				delete b[key];
			} else if (ignoreSort) {
				if (Array.isArray(a[key])) a[key].sort();
				if (Array.isArray(b[key])) b[key].sort();
			}
		});

		return _.isEqual(a, b);
	},
	campusLogos = {
		EAU: imgEAU,
		EAU_BRN: imgEAU_BRN,
		GBY: imgGBY,
		MAN: imgMAN,
		MNT: imgMNT,
		SHB: imgSHB,
		LAC: imgLAC,
		MSN: imgMSN,
		MIL: imgMIL,
		WAK: imgWAK,
		WSH: imgWSH,
		OSH: imgOSH,
		FDL: imgFDL,
		FOX: imgFOX,
		PKS: imgPKS,
		PLT: imgPLT,
		BRB: imgBRB,
		RLN: imgRLN,
		RVF: imgRVF,
		STP: imgSTP,
		MSF: imgMSF,
		MTH: imgMTH,
		STO: imgSTO,
		SUP: imgSUP,
		WTW: imgWTW,
		RCK: imgRCK,

		XMI: imgXMI,
		XPK: imgXPK
	},
	optsTerritory = {
		ASM: 'AS',
		GUM: 'GU',
		MNP: 'MP',
		PRI: 'PR',
		VIR: 'VI'
	},
	optsBadState = {
		MH: 'MHL',
		FM: 'FSM',
		PW: 'PLW'
	},
	optsVisa = [
		'U.S. Refugee/Granted Political Asylum',
		'U.S. Permanent Resident',
		'Applied/Applying for U.S. Permanent Resident Status'
	],
	direct_admit_status = () => {
		if (VITE_ENV === 'practice') return 'open';

		let d = new Date(),
			timezoneOffset = d.getTimezoneOffset();

		d = new Date(d.getTime() + (timezoneOffset - 300) * 60000);

		let month = d.getMonth() + 1,
			_date = d.getDate();

		if (month === 7) return 'open-soon';
		if (month === 6 || (month === 5 && _date > 1)) return 'closed';

		return 'open';
	},
	MSG_DIRECT_ADMIT = {
		check_for_record: (strResp, _email) => {
			const msgs = {
				claimed: (
					<>
						<h1>Direct Admit already claimed</h1>
						<p>
							<strong>{_email}</strong> has already been claimed by a Universities of Wisconsin Admission
							account. If this is you, go ahead and log in (with your personal email).
						</p>
					</>
				),
				'not found': (
					<>
						<h1>Direct Admit not found</h1>
						<p>
							We can't find a Direct Admit offer made to <strong>{_email}</strong>. If you believe you
							should have one, please contact your high school for assistance.
						</p>
						<p>Would you like to create a traditional application account instead?</p>
					</>
				)
			};

			return (
				msgs[strResp] || (
					<>
						<h1>Oops!</h1>
						<p>
							Sorry, something went wrong on our end. Please try again and let us know if the problem
							continues.
						</p>
					</>
				)
			);
		},
		send_email: (strResp, _email) => {
			const msgs = {
				'Record already claimed': (
					<>
						<h1>Direct Admit already claimed</h1>
						<p>
							<strong>{_email}</strong> has already been claimed by a Universities of Wisconsin Admission
							account. If this is you, go ahead and log in (not with your high school email).
						</p>
					</>
				),
				'Record not found': (
					<>
						<h1>Direct Admit not found</h1>
						<p>
							Do you have a Direct Admit letter referencing <strong>{_email}</strong>? Is it for the
							current academic year?
						</p>
						<p>If so, please contact your high school for further assistance.</p>
					</>
				)
			};

			return (
				msgs[strResp] || (
					<>
						<h1>Oops!</h1>
						<p>
							Sorry, something went wrong on our end. Please try again and let us know if the problem
							continues.
						</p>
					</>
				)
			);
		},
		verify_record: (strResp, _email) => {
			const msgs = {
				'Code mismatch': (
					<>
						<h1>Code mismatch</h1>
						<p>Hmm, that's not the code we sent you.</p>
					</>
				),
				'Code expired': (
					<>
						<h1>Code expired</h1>
						<p>Looks like that code has expired.</p>
					</>
				),
				'Record already claimed': (
					<>
						<h1>Direct Admit already claimed</h1>
						<p>
							That's odd. It looks like <strong>{_email}</strong> has already been claimed by a
							Universities of Wisconsin Admission account. If this is you, go ahead and log in (not with
							your high school email).
						</p>
					</>
				)
				/*  not accounted for:
						Record not found
						Code not generated
				*/
			};

			return (
				msgs[strResp] || (
					<>
						<h1>Oops!</h1>
						<p>
							Sorry, something went wrong on our end. Please try again and let us know if the problem
							continues.
						</p>
					</>
				)
			);
		}
	},
	show_message = strs => {
		if (typeof strs === 'string') strs = [strs];

		confirmAlert({
			customUI: ({ onClose }) => {
				return (
					<div className='react-confirm-alert'>
						<div className='react-confirm-alert-body'>
							{strs.map((str, i) => (
								<p key={i}>{str}</p>
							))}
							<div className='react-confirm-alert-button-group'>
								<button onClick={onClose}>OK</button>
							</div>
						</div>
					</div>
				);
			}
		});
	},
	redeem_error_messages = {
		'App not found': {
			title: 'App Not Found',
			message: "Hmm, we can't seem to find your application."
		},
		'No coupon with that code found': {
			title: 'Coupon Not Found',
			message: "Hmm, we can't seem to find that coupon code."
		},
		'Coupon used or expired': {
			title: 'Coupon Already Redeemed',
			message: 'Hmm, it seems as if that coupon has already been redeemed.'
		},
		'Coupon not yet valid': {
			title: 'Coupon Not Valid',
			message: "Sorry, it looks like that coupon isn't valid yet."
		},
		'Coupon no longer valid': {
			title: 'Coupon Expired',
			message: 'Sorry, it looks like that coupon has expired.'
		},
		'Invalid app type for coupon': {
			title: 'Wrong App Type',
			message: `It looks like that coupon can't be applied to an application of that type.`
		},
		'Invalid term for coupon': {
			title: 'Wrong Term',
			message: `It looks like that coupon can't be applied to an application with that term.`
		},
		'Invalid program for coupon': {
			title: 'Wrong Program',
			message: "It looks like that coupon can't be applied to an application with the program you've selected."
		}
	},
	doc_types = [
		{
			key: 'HSCourses',
			label: 'High School Course Schedule'
		},
		{
			key: 'HSTranscript',
			label: 'High School Transcript'
		},
		{
			key: 'CollegeTranscript',
			label: 'College Transcript'
		},
		{
			key: 'RESUME',
			label: 'Resume'
		}
	],
	masonryOptions = {
		transitionDuration: 1000,
		fitWidth: true,
		isOriginLeft: true
	};
